// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "@firebase/firestore";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAiF0O7YKkxY8LH1HtIbigI1nyhrlGrMZ0",
  authDomain: "giga-tracker.firebaseapp.com",
  projectId: "giga-tracker",
  storageBucket: "giga-tracker.firebasestorage.app",
  messagingSenderId: "93700201110",
  appId: "1:93700201110:web:1e64c37ff7b326200080b7",
  measurementId: "G-7SCYQ57ZL9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
const analytics = getAnalytics(app);